// Neu (SPEC 03 §6.2) — der EINE QueryClient der Anwendung.
//
// SPEC 03 §6.2 lässt main.tsx ihn exportieren; main.tsx tut das weiter (Wiederausfuhr). Er
// wohnt aber HIER, weil der Anmeldespeicher ihn beim Abmelden leeren muss und main.tsx beim
// Laden sofort zeichnet (createRoot) — ein Import von main.tsx aus dem Speicher wäre ein
// Kreis, und in Tests gäbe es kein #root.
import { keepPreviousData, QueryClient } from "@tanstack/react-query";
import { ApiError } from "./fetchJson";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
      // Nur wiederholen, was sich durch Wiederholen heilen lässt: ein 4xx bleibt ein 4xx.
      retry: (n, e) => n < 2 && !(e instanceof ApiError && e.status >= 400 && e.status < 500),
    },
    // Eine Änderung wird NIE von selbst wiederholt: „Charge anlegen“ zweimal ist zwei Chargen.
    mutations: { retry: false },
  },
});
